import React, { useState } from 'react'
import Plot from "react-plotly.js";
import { useOutletContext } from "react-router-dom";
import { driverDecimals } from '../HelperFunction/helperFunction'

function LineChartMarketAnalysis({ plotdatamonthly, plotdataweekly, displaynames }) {

  const { theme } = useOutletContext();
  const [plotdata1, setplotdata1] = useState({});
  const [ifweekly, setifweekly] = useState(false)
  const [seriesOn, setSeriesOn] = useState({});

  function getStartOfWeek(weekYear) {
    const [week, year] = weekYear.split('/').map(Number);

    // Validate input
    if (isNaN(week) || isNaN(year) || week < 1 || week > 53) {
      throw new Error('Invalid input: Ensure the format is "week/year" and the week is between 1 and 53.');
    }

    // January 4th is guaranteed to be in the first ISO week of the year
    const firstThursday = new Date(Date.UTC(2000 + year, 0, 4));

    // Find the first day of the first ISO week (Monday)
    const firstMonday = new Date(
      firstThursday.setUTCDate(firstThursday.getUTCDate() - ((firstThursday.getUTCDay() + 6) % 7))
    );

    // Calculate the start of the target week (Saturday instead of Monday)
    const startOfWeek = new Date(firstMonday);
    startOfWeek.setUTCDate(startOfWeek.getUTCDate() + (week - 1) * 7 + 5); // +5 days to get Saturday

    // Format as dd-mm-yyyy
    const day = String(startOfWeek.getUTCDate()).padStart(2, '0');
    const month = String(startOfWeek.getUTCMonth() + 1).padStart(2, '0');
    const yearString = startOfWeek.getUTCFullYear();

    return `${day}-${month}-${yearString}`;
  }

  const formatDate = (dateString) => {
    const [month, year] = dateString.split("-");
    const date = new Date(`${year}-${month}-01`);
    return date.toLocaleString('default', { month: 'short', year: 'numeric' }); // Short form of month
  };
  const processplotdata = (plotresponse) => {


    let arr1 = [];
    let arr2 = [];
    let arr3 = [];
    let plot_data1 = [];
    let plot_data2 = []
    const colors = [
      '#0D7C66',
      '#17A2B8',
      '#A78BFA',
      '#FF8C00',
      '#0B6B57',
      '#DC3545',
      '#198754',
      '#6C757D',
      '#0A6B57',
      '#FFC107',
      '#6610f2',
      '#fd7e14',
      '#20c997',
      '#e83e8c',
      '#6f42c1',
      '#17a2b8',
      '#343a40',
      '#28a745',
      '#007bff',
      '#ffc107',
    ];
    if (ifweekly) {
      plotresponse?.map((it, index) => {
        it?.variables.map((item) => {
          const isHighValueSeries = item?.weekly_values?.some((item) => item.rounded_value > 10000000); // Threshold for high values
          plot_data1.push(
            {
              x: item?.weekly_values?.map((it) => getStartOfWeek(it?.week_format)),
              y: item?.weekly_values?.map((it) => it?.rounded_value),
              name: `${it.market}`,
              showlegend: true,
              type: "scatter",
              mode: "lines",
              connectgaps: true,
              line: { color: colors[index], width: 2 },
              marker: { color: colors[index] },

              // yaxis: isHighValueSeries ? "y2" : "y", // Assign to the appropriate axis
            },
            {
              x: item?.weekly_values?.map((it) => getStartOfWeek(it.week_format)),
              y: linear(item?.weekly_values?.map((it) => it.week_format), item?.weekly_values?.map((it) => it.rounded_value)),
              name: `${it.market}-Linear Trendline`,
              showlegend: true,
              type: "scatter",
              mode: "lines",
              visible: "legendonly",
              marker: { color: colors[index] },

              line: {
                dash: "dot",
                width: 1,
              },

              // yaxis: isHighValueSeries ? "y2" : "y", // Match the corresponding Y-axis
            }
          );
        })

      });
      return plot_data1
    }
    else {
      plotresponse?.map((it, index) => {
        it?.variables.map((item) => {
          const isHighValueSeries = item?.monthly_values?.some((it) => it.rounded_value > 10000000); // Threshold for high values
          plot_data2.push(
            {
              x: item?.monthly_values?.map((it) => formatDate(it.month_format?.split("-")?.reverse().join("-"))),
              y: item?.monthly_values?.map((it) => it.rounded_value),
              name: `${it.market}`,
              showlegend: true,
              type: "scatter",
              mode: "lines",
              connectgaps: true,
              line: { color: colors[index], width: 2 },
              marker: { color: colors[index] },
              hovertemplate: `${it.market}: %{y:,.${driverDecimals(item?.units)}f} ${item?.units || ""}<extra></extra>`,
              // yaxis: isHighValueSeries ? "y" : "y", // Assign to the appropriate axis
            },
            {
              x: item?.monthly_values?.map((it) => formatDate(it.month_format?.split("-")?.reverse().join("-"))),
              y: linear(item?.monthly_values?.map((it) => it.month_format?.split("-")?.reverse().join("-")), item?.monthly_values?.map((it) => it.rounded_value)),
              name: `${it.market}-Linear Trendline`,
              showlegend: true,
              type: "scatter",
              mode: "lines",
              visible: "legendonly",
              marker: { color: colors[index] },

              line: {
                dash: "dot",
                width: 1,
              },
              hovertemplate: `${it.market} (trend): %{y:,.${driverDecimals(item?.units)}f} ${item?.units || ""}<extra></extra>`,
              // yaxis: isHighValueSeries ? "y" : "y", // Match the corresponding Y-axis
            }
          );
        })

      });

      return plot_data2
    }


  };
  const linear = (xAxis, data) => {
    const xaxisvalue = xAxis.length;
    const xaxis = Array.from({ length: xaxisvalue }, (_, i) => i);
    const yaxis = [];
    data.forEach((it) => yaxis.push(it));

    const n = xaxis.length;
    //console.log(xaxis,yaxis)
    // Calculate mean of X and Y
    const meanX = xaxis.reduce((sum, point) => sum + point, 0) / n;
    const meanY = yaxis.reduce((sum, point) => sum + point, 0) / n;
    //console.log(meanX,meanY)
    let numerator = 0;
    let denominator = 0;

    for (let i = 0; i < n; i++) {
      const diffX = xaxis[i] - meanX;
      const diffY = yaxis[i] - meanY;
      numerator += diffX * diffY;
      denominator += diffX * diffX;
    }

    const m = numerator / denominator;
    const b = meanY - m * meanX;

    let lineararr = [];

    xaxis.forEach((it) => {
      lineararr.push(m * it + b);
    });

    return lineararr;
  };
  const isDark = theme !== "light";
  const textColor = isDark ? "#ffffff" : "#1e293b";
  const mutedColor = isDark ? "#ADB5BD" : "#6C757D";
  const gridColor = isDark ? "rgba(148, 163, 184, 0.18)" : "rgba(148, 163, 184, 0.25)";
  const lineColor = isDark ? "rgba(148, 163, 184, 0.35)" : "rgba(15, 23, 42, 0.25)";
  const paperBg = "transparent";
  const plotBg = "transparent";

  const hasChartData = plotdataweekly.length > 0 && plotdatamonthly.length > 0;
  const isTrendName = (name) => String(name || "").includes("Linear Trendline");
  const isSeriesOn = (name) =>
    Object.prototype.hasOwnProperty.call(seriesOn, name) ? seriesOn[name] : !isTrendName(name);
  const toggleSeries = (name) => {
    setSeriesOn((prev) => {
      const current = Object.prototype.hasOwnProperty.call(prev, name) ? prev[name] : !isTrendName(name);
      return { ...prev, [name]: !current };
    });
  };
  const baseTraces = hasChartData
    ? processplotdata(ifweekly ? plotdataweekly : plotdatamonthly).map((trace) => ({
      ...trace,
      customdata: (trace.x || []).map((label) =>
        ifweekly ? { weekYear: label, startDate: label } : { month_year: label }
      ),
    }))
    : [];
  const chartTraces = baseTraces.map((trace) => ({
    ...trace,
    showlegend: false,
    visible: isSeriesOn(trace.name),
  }));
  const legendRows = baseTraces.map((trace) => ({
    name: trace.name,
    color: trace.line?.color || trace.marker?.color,
    trend: isTrendName(trace.name),
    bar: trace.type === "bar",
    on: isSeriesOn(trace.name),
  }));
  const xLabels = chartTraces[0]?.x || [];
  const xTickvals = ifweekly && xLabels.length > 18
    ? xLabels.filter((_, index) => index % 6 === 0)
    : xLabels;
  const xTickangle = xLabels.length > 16 ? -90 : -45;

  return (
    <>
      <div className="lba-page">
        <div className="rr-chart-toolbar mb-2">
            <div className="rr-chart-toolbar-left">
              <div className="rr-chip rr-chip-soft">Trend Comparison View</div>
              <h5 className="rr-chart-title mb-1">
                {displaynames?.selectedbrand}{" "}
                {displaynames?.variable ? `- ${displaynames.variable}` : ""}
              </h5>
              <p className="rr-chart-subtitle mb-0">
                Compare monthly and weekly patterns in a clean, theme-consistent
                chart experience.
              </p>
            </div>

            <div className="rr-chart-toolbar-right">
              <div className="rr-chart-toggle-group" role="group">
                <button
                  className={`rr-btn rr-btn-secondary ${!ifweekly ? "active" : ""}`}
                  onClick={() => setifweekly(false)}
                >
                  Monthly
                </button>
                <button
                  className={`rr-btn rr-btn-secondary ${ifweekly ? "active" : ""}`}
                  onClick={() => setifweekly(true)}
                >
                  Weekly
                </button>
              </div>
            </div>
          </div>

          <div className="rr-chart-shell">
            <div className="rr-card rr-card-mini">
              <div className="d-flex justify-content-center">
                {hasChartData ? (
                  <div className="rr-chart-plot-wrap w-100" style={{ minHeight: "420px" }}>
                    <Plot
                      className="w-100 plotbrandanalysis"
                      style={{ maxWidth: "100%", height: "420px", minHeight: "420px" }}
                      data={chartTraces}
                      revision={JSON.stringify(seriesOn)}
                      layout={{
                        title: {
                          text: `${displaynames?.selectedbrand} - ${displaynames?.variable}`,
                          x: 0.5,
                          xanchor: "center",
                          y: 0.97,
                          yanchor: "top",
                          font: {
                            size: 18,
                            color: textColor,
                          },
                        },
                        paper_bgcolor: "transparent",
                        plot_bgcolor: "transparent",
                        margin: { l: 64, r: 24, t: 64, b: 12 },
                        showlegend: false,
                        autosize: true,
                        xaxis: {
                          title: {
                            text: "",
                            font: {
                              color: textColor,
                              size: 13,
                            },
                          },
                          showgrid: false,
                          tickangle: xTickangle,
                          tickfont: {
                            color: mutedColor,
                            size: 11,
                          },
                          tickmode: "array",
                          tickvals: xTickvals,
                          showline: true,
                          zeroline: false,
                          linecolor: lineColor,
                          linewidth: 1,
                          automargin: true,
                          ticklen: 4,
                        },
                        yaxis: {
                          title: {
                            text: displaynames?.type ? displaynames?.type : "",
                            font: {
                              color: textColor,
                              size: 14,
                            },
                            standoff: 14,
                          },
                          rangemode: "tozero",
                          tickfont: {
                            color: mutedColor,
                            size: 12,
                          },
                          automargin: true,
                          showline: true,
                          zeroline: true,
                          zerolinewidth: 1,
                          gridcolor: gridColor,
                          zerolinecolor: "rgba(148, 163, 184, 0.2)",
                          linecolor: lineColor,
                          linewidth: 1,
                        },
                        hovermode: "x unified",
                        font: {
                          color: textColor,
                        },
                        hoverlabel: {
                          bgcolor: isDark ? "#1e293b" : "#ffffff",
                          bordercolor: isDark ? "rgba(148,163,184,0.3)" : "#e2e8f0",
                          font: {
                            color: textColor,
                          },
                        },
                      }}
                      config={{ responsive: true }}
                      useResizeHandler={true}
                    />
                  </div>
                ) : (
                  <div className="rr-card rr-card-empty w-100">
                    <div className="rr-empty-icon">📊</div>
                    <div className="rr-empty-title">No data available</div>
                    <div className="rr-empty-text">
                      There are no records to display for this chart right now.
                    </div>
                  </div>
                )}
              </div>
              {hasChartData && (
                <div className="ma-axis-caption">{ifweekly ? "Week / Year" : "Month - Year"}</div>
              )}
              {legendRows.length > 0 && (
                <div className="ma-legend-card">
                  {legendRows.map((row) => (
                    <button
                      type="button"
                      key={row.name}
                      className={`ma-legend-item${row.on ? "" : " is-off"}`}
                      onClick={() => toggleSeries(row.name)}
                    >
                      <span
                        className={`ma-legend-swatch${row.trend ? " is-dash" : row.bar ? " is-bar" : ""}`}
                        style={row.trend ? { borderTopColor: row.color } : { background: row.color }}
                      />
                      <span className="ma-legend-label">{row.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
      </div>
    </>
  );
}

export default LineChartMarketAnalysis